import { useState } from 'react'
import { useLocation } from 'wouter'
import RinaContextCard from '../components/RinaContextCard'
import PageHub from '../components/PageHub'
import MarcheProducerEvents from '../components/marche/MarcheProducerEvents'
import { ROUTES } from '../routes'

/**
 * Onglet « Évènements » du hub producteur — /producteur/marches (S62).
 *
 * Avant : cette adresse portait une ancienne page (autre design, CA a saisir)
 * atteinte par l'Explorer, et l'onglet de la barre ouvrait le MODULE plein
 * ecran avec sa propre barre Événements / Mon stand — deux barres empilees
 * (retour Daniel). Desormais l'onglet rend ICI le meme ecran que le module
 * (`MarcheProducerEvents`, une seule source), sous la barre du hub ; « Mon
 * stand » est une sous-page (/producteur/stand) avec retour.
 */
function ContenuMarchesProducteur() {
  const [, setLocation] = useLocation()
  const [flash, setFlash] = useState(null)
  const toast = (msg) => { setFlash(msg); setTimeout(() => setFlash(null), 2800) }

  return (
    <>
      {flash && (
        <div className="fixed top-4 left-1/2 -translate-x-1/2 z-[200] px-4 py-2.5 rounded-xl text-sm font-medium shadow-lg animate-fade-up text-white" style={{ background: 'rgb(var(--c-green))' }}>
          {flash}
        </div>
      )}
      <RinaContextCard message="Les évènements à venir : inscrivez-vous et dites quels produits vous apportez — la liste est pré-remplie." />

      {/* Mon stand de reference : la vitrine pre-cochee a chaque inscription */}
      <button
        onClick={() => setLocation(ROUTES.producteur.stand)}
        className="panneau-verre w-full flex items-center gap-3 text-left rounded-3xl p-4 mb-4 active:scale-[0.99] transition-transform animate-fade-up"
      >
        <span className="w-11 h-11 rounded-[14px] flex items-center justify-center text-[22px] flex-shrink-0"
          style={{ background: 'rgba(20,184,166,0.14)', border: '1px solid rgba(20,184,166,0.3)' }}>🪧</span>
        <span className="flex-1 min-w-0">
          <span className="block text-[13.5px] font-bold text-ink">Mes produits par défaut</span>
          <span className="block text-[11.5px] mt-0.5 leading-snug text-ink/60">Proposés à chaque inscription, il ne reste qu'à décocher.</span>
        </span>
        <span className="text-[13px] text-ink/50">›</span>
      </button>

      <MarcheProducerEvents onToast={toast} />
    </>
  )
}

export default function PageMarchesProducteur() {
  return <PageHub><ContenuMarchesProducteur /></PageHub>
}
